import { Button } from '@blueprintjs/core';
import { VInputField } from 'welltrax-ui-components';
import React, { useState } from 'react';

export const PasswordInputField = (props: any) => {
  const [showPassword, setShowPassword] = useState(true);

  const ShowPassWordButton = () => (
    <Button icon={showPassword ? 'eye-off' : 'eye-on'} onClick={() => setShowPassword(!showPassword)} />
  );

  const onBlur = () => {
    setShowPassword(false);
  };

  return (
    <VInputField
      {...props}
      onBlur={onBlur}
      type={showPassword ? 'text' : 'password'}
      rightElement={<ShowPassWordButton />}
      {...{ autoComplete: 'off', leftIcon: 'lock' }}
    />
  );
};

export default PasswordInputField;
